<template>
  <div class="cmsdetail">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item
          v-for="(item, index) in breadData"
          :key="index"
          :to="item.path"
          ><a>{{ item.name }}</a></el-breadcrumb-item
        > 
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="product-detail">
        <div class="goods-info">
          <div class="goods-info-left">
            
            <el-carousel indicator-position="outside" ref="carousel" :initial-index="swipe_index" @change="onSwipeChange" :autoplay="row.videos_url ? false : true" trigger="click" height="320px;" style="width:320px;overflow:hidden">
              <el-carousel-item v-if="row.videos_url">
                <video :src="row.videos_url" controls="controls" style="width:320px;height:320px"></video>
              </el-carousel-item>
              
              <el-carousel-item v-for="(item, index) in row.pics_url" :key="index">
                <img :src="item" alt srcset />
              </el-carousel-item>
            </el-carousel>
            <div class="scorll-img-box">
              <video v-if="row.videos_url" @click="onSwipeChickChange(0)" :class="swipe_index==0 ? 'scorll-items-active':'scorll-items'" :src="row.videos_url" style="min-wdith:50px;wdith:50px;height:50px"></video>
              <div @click="onSwipeChickChange(index+1)" :class="swipe_index== (row.videos_url ? index+1 :index) ? 'scorll-items-active':'scorll-items'" v-for="(item, index) in row.pics_url" :key="index">
                <img style="min-wdith:50px;wdith:50px;height:50px" :src="item" alt srcset />
              </div> 
            </div>
            <!-- <img :src="row.pic_url" alt="" srcset=""> -->
          </div>
          <div class="goods-info-main">


          <div class="text-wrapper">
            <div class="title">{{ row.title }}</div> 
 
            <div class="acea-row row-middle money-wrapper">
              <div class="money-wrap">
                <del
                  >原价：￥{{row.orig_price}}</del
                >
                <div class="acea-row row-middle">
                  <div class="price">  
                    ￥<span>
                        <b id="products" v-if="goods_price==0">{{row.price_range[0]}}</b>
                        <b id="products" v-else>{{ goods_price }}</b></span>
                  </div> 
                  <!-- <div 
                    class="acea-row vip"
                  >
                    <div class="acea-row row-center-wrapper iconfont"></div>
                    <div class="acea-row row-center-wrapper money">
                      ￥<span>111</span>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="sales acea-row row-column row-center-wrapper">
                <div class="num">
                  {{row.sold_show_count+row.sold_count}}
                </div>
                <div>销量</div>
              </div>
            </div> 
          </div>


            <div class="goods-info-main-box">
              <form class="xqq-topm">
                <!-- <div class="xqq-pmt default">
                  <h1 style="margin:10px 0">{{row.title}}</h1>
                  <div id="showTitle " class="show-two-row">{{row.desc}}</div>
                </div> -->
                <div class="xqq-pmd"> 
                  <div class="xx-dq">
                    <div v-for="(tree ,findex) in sku.tree" :key="findex">
                      <!-- <div>{{tree.k}}:</div> -->
                      <div class="default">{{ tree.k }}</div>
                      <div class="attr-box">
                        <!-- <div v-for="(attr,aindex) in tree.v" :key="aindex" :class="attr.checked ? 'active':''" @click="skuChoose(findex,aindex,attr)"> -->
                        <div
                          v-for="(attr,aindex) in tree.v"
                          :key="aindex"
                          :class="['format-list-item',attr.checked?'active':'',attr.disabled?'disabled':'']"
                          @click="skuChoose(findex,aindex,attr)"
                        >
                          <div class="pointer">{{attr.name}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <p class="xq-bz">
                  下单备注：
                  <span>下单前请先联系右方客服确认最新报价</span>
                </p>-->
                <div class="lj-gm">
                  <a href="javascript:;" class="lj-gml" @click="toBuy(1)">立即购买</a>
                  <a
                    href="javascript:;"
                    id="addcarts"
                    class="lj-gmr add_cart_large btnCart"
                    @click="toBuy(2)"
                  >加入购物车</a>
                  
                  <!--                            onclick="submitGo();"-->
                </div>
                 
              </form>
              <div class="main-right default" v-if="false">
                <p class="p1">客服咨询</p>
                <img style="width:120px;height:120px;" :src="chat.pic_url" alt />
                <p v-if="chat.wxcode">WeChat:{{ chat.wxcode }}</p>
                <div class="service-btn pointer">点击联系客服</div>
                <p class="p2 default">免费预约顾问，极速为您服务</p>
                <input type="text" id="name" placeholder="请输入您的姓名" />
                <input type="text" id="phone" placeholder="请输入您的电话号码" />
                <div class="appointment-btn pointer" @click="onAppointment">免费预约</div>
              </div>
            </div>
            <div class="product-detail-box">
              <div class :class="pos_status? 'goods-detail-pos':''">
                <div class="goods-detail">
                  <!-- <a
                    href="#one"
                    ref="one"
                    :style="active_status==1 ? 'background:#FE6B01;color:#fff':''"
                    @click="onTabsChange(1)"
                  >基本信息</a> -->
                  <!-- <a
                    href="#two"
                    ref="two"
                    :style="active_status==2 ? 'background:#FE6B01;color:#fff':''"
                    @click="onTabsChange(2)"
                  >商品详情</a> -->
                  <!-- <a href="#thr" ref="thr" :style="active_status==3 ? 'background:#e84f4e;color:#fff':''"
                                    @click="onTabsChange(3)">常见问题</a>
                                <a href="#for" ref="for" :style="active_status==4 ? 'background:#e84f4e;color:#fff':''"
                  @click="onTabsChange(4)">相关推荐</a>-->
                </div>
              </div>
              <!-- <div ref="myNav" id="one"></div>
              <div class="one" style>
                <div style="padding:20px;display:flex" class="default">
                  <span class="detail-solid"></span> 基本信息
                </div>
                
              </div> -->
              <div id="two"></div>
            </div>
          </div>

          
        </div>


              <div class="one" style>
                <div style="padding:20px;display:flex" class="default">
                  <span class="detail-solid"></span> 商品详情
                </div>
                <div class="goods-detail-row-list default">
                  <div v-for="(item ,i) in row.extra_data" :key="i">
                    <span>{{item.name}}</span> :
                    <span style="flex:1">{{item.value}}</span>
                  </div>
                </div>
                <div style="padding: 10px 30px;" v-html="row.content" class="html-data"></div>
              </div>
      </div>
    </div>
    <div class="order-box" v-if="order_visible">
      <div class="order-center" v-if="order_visible">
        <p class="order-center-title flex-between">
          确认购买
          <img
            @click="onClose"
            style="width: 25px;height:25px;cursor: pointer;"
            src="https://www.meijiexia.cn/statics/new/201805/images/tk_close.png"
            alt
          />
        </p>
        <div class="order-goods flex-between">
          <img :src="row.pic_url" alt srcset />
          <div class="order-title">
            <p class="show-two-row">{{row.title}}</p>
          </div>
          <div class="order-sku show-two-row">{{ goods_sku_names }}</div>
          <div class="goods-price-count">
            <p class="default">单价:¥{{ goods_price }}</p>
            <p class="default">数量 :{{ goods_count }}</p>
          </div>
          <div class="pay-price default">
            总计:
            <span style="color:#0175c0">¥{{ goods_pay_price }}</span>
          </div>
        </div>
        <div class="order-count-add">
          <span class="default">购买数量 :</span>
          <el-input-number v-model="goods_count" @change="handleChange" :min="1" :max="100" label></el-input-number>
        </div>
        <div class="all-pay_price">
          <div>
            应付:
            <span style="color:#0175c0">¥{{ goods_pay_price }}</span>
          </div>
          <div class="order-add flex-center pointer" @click="orderAdd" v-if="buyAddStatus==1">提交订单</div>
          <div
            class="order-add flex-center pointer"
            @click="orderAddCart"
            v-if="buyAddStatus==2"
          >加入购物车</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GoodsDetail",
  data() {
    return {
      breadData: [{ name: "首页", path: "/indexpc" },{ name: "采购商城", path: "/goodslist" }], //面包屑的内容

      order_visible: false,
      pos_status: false,
      active_status: 1,
      row: {
        title: "",
        pic_url: [],
        price_range: []
      },
      sku: {
        list: [],
        tree: []
      },
      buyCount: 0,
      buyCountMax: 1,
      price: "-",
      stock: 0,
      quotaNum: 0,
      pageHeight: "0",
      k_s_checked: {}, //选中的条件,
      checked_sku_list: [], //选中的sku
      sku_checked_ok: false, //规格是否选中完毕,
      quota: 0,
      quotaUsed: 0,
      goods_price: 0,
      goods_count: 1,
      goods_pay_price: 0,
      goods_sku_names: "",

      buySkuId: 0,
      buyGoodsCount: 1,
      buyGoodsId: 0,
      buyAddStatus: 2,
      chat: {
        pic_url: ""
      },
      goodsId: 0,
      swipe_index:0
    };
  },
  mounted() {
    this.goodsId = this.$route.query.id;
    this.getGoodsDetail();
  },
  methods: {
    onAppointment() {
      let that = this;
      let formData = {
        name: $(" #name ").val(),
        phone: $(" #phone ").val(),
        desc: that.row.title + ",预约顾问咨询",
        service_type: "appointment"
      };
      that.phoneCheck(formData.phone);

      post(
        "api/kefu/messageAdd",
        formData,
        res => {
          console.log(res);
          that.$message.success("客服将尽快与您联系，请耐心等待~");
        },
        res => {
          console.log(res);
          that.$message.error("不好意思,出错啦!");
        }
      );
    },
    onCollection() {
      let that = this;
      post(
        "/api/goods/goodsCollectionAdd",
        { id: that.goodsId },
        res => {
          console.log(res);
          that.$message.success("收藏成功!");
        },
        res => {
          that.$message.error(res.msg);
        }
      );
    },
    phoneCheck(phone) {
      let that = this;
      if (!phone) {
        that.$message.error("手机号不能为空");
        return;
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(phone));
        if (reg.test(phone)) {
        } else {
          that.$message.error("请输入正确的手机号");
          return;
        }
      }
    },
    orderAddCart() {
      let that = this;
      let goods_items = {
        goods_id: that.buyGoodsId,
        sku_id: that.buySkuId,
        count: that.buyGoodsCount
      };
      that.$api.post("/api/cart/add", goods_items, res => {
        console.log(res);
 

        if (res.code == 200) {
          that.$message.success("添加成功!");
        } else {
          that.$message.error(res.msg);
        }
        that.order_visible = false;
      },res =>{
        console.log(res);

        if (res.code == 401 || res.code == 402) {
          rbLink({
            name:'login'
          })
          return ;
    
        } 

      });
    },
    orderAdd() {
      let that = this;
      let goods_items = [
        {
          goods_id: that.buyGoodsId,
          sku_id: that.buySkuId,
          count: that.buyGoodsCount
        }
      ];
      // 存入缓存
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );
      console.log(localStorage.getItem("order_check_goods_items"));
      this.$router.push({ path: "/orderpay" });
    },
    handleChange(value) {
      console.log(this.goods_price, value);
      this.goods_pay_price = (this.goods_price * value).toFixed(2);
      this.buyGoodsCount = value;
    },

    getGoodsDetail() {
      let that = this;
      that.$api.get("/api/goods/goodsdetail", { id: that.goodsId }, res => {
        that.row = res.data.data;
        that.sku = res.data.sku;
        that.buyGoodsId = res.data.data.id;
        that.chat = res.data.chat;
        that.skuPickerShow();
      });
    },
    skuPickerShow() {
      console.log("skuPickerShow");
      let that = this;
      console.log(this);
      that.sku.tree.map((field, findex) => {
        if (field.v.length == 1) {
          //仅有一个属性，默认选择
          var s = "sku.tree[" + findex + "].v[0].checked";
          // that.sku.tree[findex].v[0]['checked']=true
          this.$set(this.sku.tree[findex].v[0], "checked", true);
        } else {
          that.sku.tree[findex].v.map((item, index) => {
            // that.sku.tree[findex].v[index]['checked']=false
            this.$set(this.sku.tree[findex].v[index], "checked", false);
          });
        }
      });
      that.skuCompute();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onTabsChange(value) {
      this.active_status = value;
    },
    skuChoose(findex, aindex, attr) {
      let that = this;
      console.log(attr);

      if (attr.disabled) {
        //禁止选择
        return;
      }
      if (that.sku.tree[findex].v.length == 1) {
        //仅有一个属性
        return;
      }

      that.sku.tree[findex].v.map(child => {
        child.checked = false;
      });
      console.log(
        "that.sku.tree[findex].v[aindex].checked",
        that.sku.tree[findex].v[aindex].checked
      );
      console.log(attr.checked);
      if (attr.checked) {
        //取消选中
        that.sku.tree[findex].v[aindex].checked = false;
        attr.checked = false;
      } else {
        //选中
        that.sku.tree[findex].v[aindex].checked = true;
        attr.checked = true;
      }
      console.log(
        "that.sku.tree[findex].v[aindex].checked",
        that.sku.tree[findex].v[aindex].checked
      );
      that.sku.tree[findex].v[aindex] = attr;
      console.log(that.sku.tree[findex]);
      that.skuCompute();
    },

    skuCompute() {
      //过滤sku-list
      let that = this;
      console.log("skuCompute", that.sku.tree);
      let k_s_checked = {};
      that.sku.tree.map(field => {
        var hasChecked = field.v.filter(attr => {
          return attr.checked;
        });
        if (hasChecked.length > 0) {
          // k_s_checked.push({
          // 'k': field.k_s,
          // 'v': hasChecked[0].id,
          // });
          k_s_checked[field.k_s] = hasChecked[0].id;
        }
      });
      //选中的条件
      console.log("k_s_checked", k_s_checked);
      let checked_sku_list = that.checkedSkuFilter(k_s_checked);
      that.k_s_checked = k_s_checked;
      that.checked_sku_list = checked_sku_list;
      // that.setData({
      //   k_s_checked: k_s_checked,
      //   checked_sku_list: checked_sku_list
      // })

      //选中的sku
      console.log("checked_sku_list", checked_sku_list);
      that.skuTitleCompute();
      that.disabledCompute();
      that.buyCountCompute();
    },
    skuTitleCompute() {
      //实时计算价格，总库存
      let that = this;
      var minPrice = 999999999;
      var maxPrice = 0;
      var stock = 0;
      console.log(that.checked_sku_list);
      if (that.checked_sku_list.length > 0) {
        that.checked_sku_list.map(row => {
          minPrice = minPrice >= row.price ? row.price : minPrice;
          maxPrice = maxPrice <= row.price ? row.price : maxPrice;
          stock += row.stock_num;
        });
      } else {
        minPrice = 0;
      }

      that.stock = stock;
      that.price =
        minPrice == maxPrice
          ? minPrice 
          : minPrice  + "-" + maxPrice ;
      // that.setData({
      //   stock: stock,
      //   price: minPrice == maxPrice ? minPrice  : (minPrice ) + '-' + (maxPrice),

      // });
      that.quotaNum =
        this.quota - this.quotaUsed > 0
          ? this.quota - this.quotaUsed
          : this.stock;
      // that.setData({
      //   quotaNum: quotaNum
      // })
      console.log("that.stock", that.stock);
      console.log("that.price", that.price);
      that.goods_price = that.price;
    },
    disabledCompute() {
      //计算不可选项目
      let that = this;
      let tree = that.sku.tree;
      tree.map(field => {
        field.v.map(attr => {
          //满足当前attr的sku列表
          let k_s_checked_tmp = that.k_s_checked;
          k_s_checked_tmp[field.k_s] = attr.id;
          attr.k_s_checked_tmp = k_s_checked_tmp;
          let checked_sku_list = that.checkedSkuFilter(k_s_checked_tmp);

          var stock = 0;
          checked_sku_list.map(row => {
            stock += row.stock_num;
          });
          attr.disabled = stock > 0 ? false : true;
          attr.dstock = stock;
        });
      });
      // console.log('tree', tree);
      var s = "sku.tree";
      that.sku.tree = tree;
      // that.sku.tree=11
      console.log(that.sku, "--");

      // that.setData({
      //   [s]: tree
      // });
    },
    checkedSkuFilter(k_s_checked) {
      //根据条件，过滤skulist
      let that = this;
      let checked_sku_list = [];
      // console.log('过滤前', that.data.sku.list);
      that.sku.list.map(row => {
        // if (k_s_checked)
        // console.log('xxxx')
        for (let kitem in k_s_checked) {
          if (row[kitem] != k_s_checked[kitem]) {
            return;
          }
        }
        checked_sku_list.push(row);
      });
      // console.log('过滤后', k_s_checked, checked_sku_list);
      return checked_sku_list;
    },
    buyCountCompute() {
      var quotaNum = this.quota - this.quotaUsed;

      // this.setData({
      //   quotaNum: quotaNum
      // })
      console.log(this.quota, quotaNum);
      //计算可买的数量
      let that = this;
      if (that.checked_sku_list.length > 1) {
        console.log(this.quota, quotaNum);
        that.buyCountMax = that.quota == 0 ? that.stock : quotaNum;
        that.buyCount = 0;
        that.sku_checked_ok = false;

        return false;
      } else {
        (that.buyCountMax =
          that.quota == 0 ? that.checked_sku_list[0].stock_num : quotaNum),
          (that.buyCount = 1);
        that.sku_checked_ok = true;
      }
    },

    toBuy(e) {
      let that = this;
      console.log(e);
      that.buyAddStatus = e;
      console.log(that);
      if (!that.sku_checked_ok) {
        console.log("sku_checked_ok", that.sku_checked_ok);
        this.$message.error("请先选择规格");
        return false;
      }
      console.log(this.checked_sku_list[0], "-------");
      that.sku.tree.map((item, i) => {
        let op = "s_" + (i + 1);
        item.v.map(vs => {
          console.log(that.checked_sku_list[0][op], vs.id);
          if (that.checked_sku_list[0][op] == vs.id) {
            that.goods_sku_names = that.goods_sku_names + vs.name;
          }
        });
      });
      // console.log(that.goods_sku_names)
      this.goods_pay_price = this.goods_count * this.goods_price;
      that.order_visible = true;
      that.buySkuId = this.checked_sku_list[0].id;

      // this.triggerEvent("toBuy", {
      //     sku: that.checked_sku_list[0],
      //     buyCount: that.buyCount
      // });
      // this.onClose();
    },
    onClose() {
      this.order_visible = false;
      this.goods_count = 1;
      this.goods_pay_price = 0;
      // this.goods_price=0
      this.goods_sku_names = "";
    },
    onSwipeChange(e){
      console.log(e)
      this.swipe_index=e
    },
    onSwipeChickChange(val){
      if(this.row.videos_url){
        this.swipe_index=val
      this.$refs.carousel.setActiveItem(val)

      }else{
      this.swipe_index=val-1
      this.$refs.carousel.setActiveItem(val-1)

      }
    }
  },
  components: {},
  updated() {
    let obj = document.getElementsByClassName("edui-upload-video");
    for (let i = 0; i < obj.length; i++) {
      obj[i].style.width = "80%";
      obj[i].style.height = "500px";
    }
  }
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
}
.cmsdetail {
  width: 100%;
  // background: #f4faff;
  background: #fff;
  height: 100%;
  overflow: hidden;
}
.product-detail {
  width: 1200px;
  margin: 0 auto;
}
.product-items {
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 10px;
}
.product-items img {
  width: 245px;
  height: 245px;
}
.product-items .p1 {
  padding: 0 10px;
  height: 50px;
  font-size: 16px;

  font-weight: 400;
  color: #333333;
  line-height: 25px;
  margin: 5px 0;
}
.product-items .product-price {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.product-items .product-price .price {
  height: 28px;
  font-size: 20px;

  font-weight: 400;
  color: #ff6a00;
  line-height: 28px;
}
.product-items .product-price .collection {
  height: 28px;
  font-size: 14px;

  font-weight: 400;
  color: #999;
  line-height: 28px;
  display: flex;
  align-items: center;
}
.product-items .product-price .collection img {
  margin-top: -1px;
}
.product-items .product-btn {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #eeeeee;
  height: 40px;
}
.product-items .product-btn .cart-add {
  border-right: 1px solid #eeeeee;
  font-size: 14px;

  font-weight: 400;
  color: #333333;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-items .product-btn .cart-add img {
  margin-right: 2px;
}
.product-items .product-btn .buys-add {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;

  font-weight: 400;
  color: #ff6a00;
}
.product-items:last-child {
  border-bottom: none;
}
.recom {
  height: 71px;
  background: #fe6b01;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.recom p {
  margin: 0;
}
.recom .p1 {
  height: 28px;
  font-size: 20px;

  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  padding-left: 20px;
}
.recom .p2 {
  height: 20px;
  font-size: 14px;

  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  padding-left: 20px;
}
.product-detail-box {
  width: 100%;
  margin: 30px 25px 0 25px;
}
.goods-info-main {
  flex: 1;
}
.goods-info-main .goods-info-main-box {
  display: flex;
  justify-content: space-between;
}
.goods-info-main .goods-info-main-box .main-right {
  flex: 1;
  margin-left: 20px;
  background: #fff;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.goods-info-main .goods-info-main-box .main-right .p1 {
  height: 33px;
  font-size: 24px;

  font-weight: 400;
  color: #666666;
  line-height: 33px;
  margin-bottom: 10px;
}
.goods-info-main .goods-info-main-box .main-right .p2 {
  height: 22px;
  font-size: 16px;

  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin: 10px;
}
.goods-info-main .goods-info-main-box .main-right .service-btn {
  width: 80%;
  height: 40px;
  background: #fe6b01;
  border-radius: 30px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  margin-top: 15px;
}
.goods-info-main .goods-info-main-box .main-right .appointment-btn {
  width: 50%;
  height: 40px;
  background: #fe6b01;
  border-radius: 30px;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
.goods-info-main .goods-info-main-box .main-right input {
  width: 80%;
  height: 35px;
  line-height: 35px;
  margin-bottom: 15px;
  text-indent: 15px;
}
p a {
  color: #333;
}
.order-box {
  width: 100%;
  height: 100vh;
  top: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
.order-box .order-center {
  width: 1200px;
  margin: 100px auto;
  height: 330px;
  background: #fff;
}
.order-box .order-center .order-center-title {
  margin: 0;
  padding: 20px;
  color: #333;
  font-size: 20px;
}
.order-box .order-center .order-goods {
  padding: 0 20px;
}
.order-box .order-center .order-goods img {
  width: 100px;
  height: 100px;
  margin: 0 20px;
}
.order-box .order-center .order-goods .order-title {
  height: 52px;
  width: 250px;
}
.order-box .order-center .order-goods .order-title p {
  width: 100%;
  height: 52px;
  line-height: 26px;
  margin: 0;
  color: #333;
}
.order-box .order-center .order-goods .order-sku {
  width: 200px;
}
.order-box .order-center .order-goods .order-sku p {
  height: 26px;
  line-height: 26px;
}
.order-box .order-center .order-goods .goods-price-count {
  width: 150px;
}
.order-box .order-center .order-goods .pay-price {
  width: 150px;
  color: #0175c0;
}
.order-box .order-center .order-count-add {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
}
.order-box .order-center .order-count-add .el-input-number span {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-box .order-center .all-pay_price {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
  padding: 0 20px;
  margin-top: 30px;
}
.order-box .order-center .all-pay_price span {
  font-size: 22px;
}
.order-box .order-center .all-pay_price .order-add {
  padding: 5px 25px;
  background: #0175c0;
  font-size: 600;
  color: #fff;
  border-radius: 5px;
  margin-top: 10px;
}

.attr-box {
  display: flex;
  flex-wrap: wrap;
}
.attr-box .format-list-item {
  padding: 5px 10px;
  border: 1px solid #ccc;
  margin-right: 5px;
  cursor: pointer;
}
.format-list-item:hover {
  border: 1px solid #0175c0;
}
.attr-box .active {
  color: #0175c0;
  border: 1px solid #0175c0;
}
.detail-solid {
  height: 18px;
  width: 3px;
  margin-right: 10px;
  display: block;
  background: #0175c0;
}
.goods-detail-row-list {
  display: flex;
  padding: 0 30px;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.goods-detail-row-list div {
  width: 48%;
  line-height: 40px;
  text-indent: 5px;
  display: flex;
  /* justify-content: space-between; */
  border: 1px solid #ccc;
}
.one {
  width: 100%;
}
.one p {
  width: 100%;
}
.one img {
  width: 100%;
}
.goods-detail a {
  display: block;
  height: 40px;
  width: 100px;
  text-align: center;
  line-height: 40px;
  color: #000;
}
.goods-detail {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #0175c0;
  display: flex;
}
.goods-detail-pos {
  background: #f0f2f5;
  width: inherit;
  /* border-bottom: 1px solid #e84f4e; */
}
.bz-c .bz-ca {
  width: 100px;
  height: 18px;
  color: #666;
}
.xqq-topm {
  width: 615px;
  margin: 0 25px 0 25px;
}
.xqq-topm .xqq-pmt {
  padding-top: 15px;
  position: relative;
  padding-left: 17px;
}
.xqq-topm .xqq-pmt h1 {
  font-size: 20px;
  color: #333;
  line-height: 55px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-box-orient: vertical;
}
.xqq-topm .xqq-pmt div {
  font-size: 14px;
  color: #666;
  height: 40px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.xqq-pmtp {
  width: 215px;
  min-height: 70px;
  height: auto;
  overflow: hidden;
  top: 95px;
  left: 360px;
  position: absolute;
  background: #fff;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  box-shadow: 0 0 10px 5px #e5e5e5;
  padding: 5px 15px;
  line-height: 16px;
  font-size: 12px;
  display: none;
}
.xqq-topm .xqq-pmw {
  width: 615px;
  height: 33px;
  background: #e5e5e5;
  line-height: 33px;
}
.xqq-topm .xqq-pmw p {
  display: block;
  height: 20px;
  line-height: 20px;
  color: #0175c0;
  padding: 0 10px;
  border: 1px solid #0175c0;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  float: left;
  margin: 6px 8px 0 15px;
}
.xqq-topm .xqq-pmw span {
  color: #333;
}
.xqq-topm .xqq-pmd {
  width: 581px;
  /* min-height: 105px; */
  background: #fff;
  padding: 0 17px 8px;
}
.xqq-topm .xqq-pmd .xqq-pmda {
  width: 581px;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  justify-content: flex-start;
}
.xqq-topm .xqq-pmd .xqq-pmda p.xqa-p {
  color: #666666;
  float: left;
}
.xqq-topm .xqq-pmd .xqq-pmda p.xqa-p span {
  color: #0175c0;
  font-size: 26px;
  line-height: 56px;
}
p.xqa-pa {
  float: right;
  color: #039ddd;
  font-size: 12px;
}
.xx-dq {
  width: 580px;
  /* height: 50px; */
  margin: 8px auto;
  line-height: 25px;
}
.xx-dq .xx-dqh {
  width: 580px;
  height: 25px;
  line-height: 25px;
}
.lj-gm {
  width: 445px;
  height: 40px;
  margin-left: 17px;
  margin-top: 20px;
}
.lj-gm a.lj-gml {
  width: 155px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 18px;
  border: 1px solid #0175c0;
  float: left;
  color: #0175c0;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
}
.lj-gm a.lj-gmr {
  width: 155px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  font-size: 18px;
  border: 1px solid #0175c0;
  float: left;
  margin-left: 20px;
  color: #fff;
  background: #0175c0;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
}
.lj-gm a.soucang {
  padding: 0 10px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0175c0;
  margin-left: 20px;
}
.lj-gm img {
  width: 22px;
  height: 22px;
}
.bz-c {
  width: 580px;
  height: 18px;
  line-height: 18px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-around;
}
.li-la {
  width: 190px;
  height: 50px;
  margin: 20px auto;
}
.li-la .li-lal {
  width: 90px;
  height: 50px;
  float: left;
  text-align: center;
}
.li-la .li-lal p.la-p {
  height: 18px;
  line-height: 20px;
  color: #666;
  font-size: 12px;
}
.li-la .li-lal span {
  font-size: 14px;
  color: #333;
  line-height: 30px;
}
p.la-pa {
  float: left;
  color: #666;
}
.li-la .li-lal {
  width: 90px;
  height: 50px;
  float: left;
  text-align: center;
}
.goods-info-left img {
  width: 100%;
  // height: 200px;
}
.scorll-img-box{
  width:320px;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
}
.scorll-img-box img{
  width: 50px !important;
  min-width: 50px !important;
}
.scorll-img-box video{
  width: 50px !important;
  min-width: 50px !important;
}
.scorll-items-active{
  border: 2px solid #333;
}
.scorll-items{
  border: 2px solid #fff;

}
.goods-info-left,
.goods-info-right {
  width: 320px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.goods-info {
  width: 100%;
  padding: 20px 0;
  display: flex;
  align-items: flex-start;
}
.disabled {
  background: #ccc !important;
  border: 1px solid #ccc !important;
  color: #333;
}



  .text-wrapper {
    flex: 1;
    min-width: 0;
    margin-left: 40px;
		.presaleTime{
			color: #5a5a5a;
			font-size: 13px;
			margin-top: 14px;
			.red{
				color: #E93323;
			}
			.iconfont{
				font-size: 13px;
				margin-right: 3px;
			}
		}

    .title {
      font-size: 20px;
      line-height: 26px;
      color: #333333;
      .labelN{
         font-size:15px;
         color: #E93323;
         border:1px solid #E93323;
         border-radius: 3px;
         padding: 2px 4px;
         margin-right: 8px;
      }
    }

    .money-wrapper {
      height: 78px;
      margin-top: 18px;
      background: url("~@/assets/images/goods-detial-bg.png") center/cover no-repeat;
      color: #ffffff;

      .money-wrap {
        flex: 1;
        min-width: 0;
        padding-left: 32px;
      }

      del {
        margin-bottom: 10px;
        font-size: 14px;
      }

      .price {
        font-size: 22px;
				.presaleLabel{
					font-size: 14px;
				}

        span {
          font-weight: bold;
          font-size: 30px;
        }
      }

      .vip {
        width: 100px;
        height: 25px;
        border-radius: 2px;
        margin-left: 14px;
        background: linear-gradient(205deg, #fdcaa4 0%, #fce3c3 100%);
        overflow: hidden;
        font-size: 12px;
        color: #0f0f0f;

        .iconfont {
          width: 32px;
          background: url("~@/assets/images/svip.png") center/cover no-repeat;
          height: 25px;
        }

        .iconfontVip {
          width: 32px;
          background: url("~@/assets/images/vip.png") center/cover no-repeat;
          height: 25px;
        }

        .money {
          flex: 1;
          min-width: 0;

          span {
            font-size: 14px;
          }
        }
      }

      .sales {
        position: relative;
        height: 100%;
        padding-right: 20px;
        padding-left: 20px;
        font-size: 12px;

        &::before {
          content: "";
          position: absolute;
          top: 14px;
          bottom: 12px;
          left: 0;
          width: 1px;
          border-left: 1px solid rgba(255, 255, 255, 0.24);
        }

        .num {
          margin-bottom: 3px;
          font-weight: bold;
          font-size: 18px;
        }
      }

      .timer-wrapper {
        width: 180px;
        margin-right: 15px;
        font-size: 12px;
        color: #ffffff;

        /deep/.styleAll {
          width: 24px;
          height: 24px;
          margin-right: 3px;
          margin-left: 3px;
          background-color: #ffffff;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #e93323;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .progress-group {
          margin-top: 10px;
        }

        .progress {
          width: 120px;
          height: 8px;
          border: 1px solid #ffffff;
          border-radius: 4px;
          font-size: 0;

          span {
            display: inline-block;
            width: 50%;
            height: 100%;
            border-radius: 4px;
            background-color: #ffffff;
          }
        }
      }
    }

    .coupon-wrapper {
      background-color: #f7f7f7;

      .coupon-bd {
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 12px;
        color: #5a5a5a;

        .label {
          width: 80px;
          padding-left: 20px;
        }

        .list {
          flex: 1;
          min-width: 0;
          padding-right: 24px;
          max-height: 240px;
          overflow-y: auto;
          overflow-x: hidden;

          &.on {
            max-height: 100px;
            overflow: hidden;
          }
        }

        .item {
          margin-top: 11px;

          &:first-child {
            margin-top: 0;
          }
        }

        .cell-left {
          width: 65px;
        }

        .cell-right {
          flex: 1;
          min-width: 0;
          color: #e93323;
        }

        .cell {
          width: 165px;
          height: 24px;
          background: url("~@/assets/images/coupon-back.png") left top/100% 100%
            no-repeat;
          font-size: 13px;
          color: #ffffff;
          &.svip {
            background-image: url("~@/assets/images/vipCou.png");
            color: #fdd7b4;
            .cell-right {
              color: #333333;
            }
          }
        }

        .time {
          flex: 1;
          min-width: 0;
          padding-right: 8px;
          padding-left: 8px;
          font-size: 12px;
          color: #727272;
        }

        button {
          border: none;
          border-bottom: 1px solid #e93323;
          background: none;
          font-size: 12px;
          color: #e93323;

          &:disabled {
            border-color: #c0c4cc;
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }
      }

      .coupon-ft {
        height: 36px;
        padding-right: 24px;
        background-color: #f2f2f2;

        .button {
          font-size: 12px;
          color: #666666;
          cursor: pointer;

          .iconfont {
            margin-left: 7px;
            font-size: 10px;
            color: #666666;
          }
        }
      }
    }
    .bntAttr{
      color: #666666;
      font-size: 12px;
      margin-top: 10px;
      cursor: pointer;
      .iconfont{
        font-size: 12px;
        margin-left: 7px;
      }
    }
    .attribute {
      margin-top: 30px;
      &.on{
        max-height: 278px;
        overflow: hidden;
      }
      .size-wrapper {
        .label {
          width: 105px;
          padding-left: 20px;
          font-size: 12px;
          color: #5a5a5a;
          margin-right: 2px;
          word-break: break-all;
        }

        .list {
          flex: 1;
          min-width: 0;
        }

        .item {
          margin-right: 12px;
          margin-bottom: 16px;
          box-sizing: border-box;
          cursor: pointer;

          .cont {
            position: relative;
            min-height: 32px;
            border: 1px solid #d3d3d3;
          }

          &:hover {
            .cont {
              border-color: #e93323;
              color: #e93323;
            }
          }

          input:checked {
            + .cont {
              border-color: #e93323;
              color: #e93323;

              .iconfont {
                display: block;
              }
            }
          }
        }

        .image {
          width: 34px;
          height: 34px;
        }

        img {
          display: block;
          width: 100%;
          height: 100%;
        }

        .name {
          padding-right: 20px;
          padding-left: 20px;
          font-size: 12px;
        }

        .iconfont {
          position: absolute;
          right: -3px;
          bottom: -4px;
          display: none;
          font-size: 22px;
        }
      }
    }

    .number-wrapper {
      margin-top: 18px;

      .label {
        width: 78px;
        padding-left: 20px;
        font-size: 12px;
        color: #5a5a5a;
        margin-right: 2px;
        word-break: break-all;
      }

      .counter-wrap {
        flex: 1;
        min-width: 0;

        span {
          vertical-align: bottom;
          font-size: 14px;
          color: #5a5a5a;
        }
      }

      .counter {
        display: inline-block;
        border: 1px solid #d3d3d3;
        font-size: 0;

        button {
          width: 44px;
          height: 36px;
          border: none;
          background: none;
          outline: none;
          font-weight: inherit;
          font-size: 12px;
          font-family: inherit;
          color: #707070;
          vertical-align: middle;

          &:disabled {
            color: #d0d0d0;
            cursor: not-allowed;
          }
        }

        input {
          width: 64px;
          height: 36px;
          border: none;
          border-right: 1px solid #d3d3d3;
          border-left: 1px solid #d3d3d3;
          outline: none;
          font-weight: inherit;
          font-size: 18px;
          font-family: inherit;
          text-align: center;
          color: #5a5a5a;
          vertical-align: middle;
        }
      }
    }

    .button-wrapper {
      margin-top: 46px;
      font-size: 0;

      .btn {
        width: 158px;
        height: 50px;
        border: 1px solid #e93323;
        border-radius: 4px;
        font-size: 16px;
        color: #e93323;

        ~ .btn {
          margin-left: 18px;
        }
      }

      button {
        background: none;
        outline: none;
        vertical-align: middle;

        &:disabled {
          border-color: #ddd;
          color: #fff;
          cursor: not-allowed;
					background-color: #ddd;
        }

        &.cart {
          background-color: #e93323;
          color: #ffffff;

          &:disabled {
            border-color: #fab6b6;
            background-color: #fab6b6;
          }
        }

        ~ button {
          margin-left: 18px;
        }
      }

      a {
        display: inline-block;
        background-color: #e93323;
        vertical-align: middle;
        line-height: 50px;
        text-align: center;

        &.btn {
          color: #ffffff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GoodsDetail.vue?4fe7cbfa